export default __webpack_public_path__ + "static/process-2-d92d6a71a51f0f7481f116d8cb39ab12.png";